<template>
  <div class="redefinir-senha">
    <el-main>
      <el-row class="redefinir-senha-container" :gutter="20">
        <el-col :span="24" class="redefinir-senha-card-container">
          <el-card class="redefinir-senha-card">
            <div v-if="status === 'loading'" class="estado">
              <i class="el-icon-loading estado-icone" aria-hidden="true"></i>
              <h3>{{ i18n.salvando }}</h3>
            </div>
            <div v-else-if="status === 'form'" class="estado estado--form">
              <h3>{{ i18n.titulo }}</h3>
              <p class="descricao">{{ i18n.descricao }}</p>
              <el-form
                ref="form"
                :model="form"
                :rules="rules"
                class="login-form redefinir-senha-form"
                @submit.native.prevent="submitForm"
              >
                <el-form-item prop="senha">
                  <template #label>
                    {{ i18n.labelSenha }}
                  </template>
                  <el-input
                    v-model="form.senha"
                    class="input-login"
                    type="password"
                    :placeholder="i18n.placeholderSenha"
                    autocomplete="new-password"
                  />
                </el-form-item>
                <el-form-item prop="confirmarSenha">
                  <template #label>
                    {{ i18n.labelConfirmarSenha }}
                  </template>
                  <el-input
                    v-model="form.confirmarSenha"
                    class="input-login"
                    type="password"
                    :placeholder="i18n.placeholderConfirmarSenha"
                    autocomplete="new-password"
                  />
                </el-form-item>
                <el-form-item class="redefinir-senha-form__acao">
                  <el-button
                    type="primary"
                    class="big-button green-filled"
                    native-type="submit"
                  >
                    {{ i18n.botaoSalvar }}
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
            <div v-else class="estado">
              <i
                :class="[
                  'estado-icone',
                  status === 'success'
                    ? 'el-icon-success estado-icone--sucesso'
                    : 'el-icon-error estado-icone--erro'
                ]"
                aria-hidden="true"
              ></i>
              <h3>{{ tituloResultado }}</h3>
              <p class="descricao">{{ descricaoResultado }}</p>
              <p class="redirect-hint">
                {{ formatarMensagem("redirecionamentoEm", segundosRestantes) }}
              </p>
              <el-button type="primary" @click="irParaLogin">
                {{ formatarMensagem("irLoginComContagem", segundosRestantes) }}
              </el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import LoginService from "../../services/LoginService";
import { applyLocaleFromQuery } from "../../utils/i18nFromRoute";
import { isBrowserLanguagePortuguese } from "../../utils/browserUiLocale";
import {
  PT_VALIDATION,
  EN_VALIDATION
} from "@/utils/messages/validation/validation";

const SEGUNDOS_REDIRECIONAMENTO = 5;

export default {
  name: "RedefinirSenha",
  data() {
    return {
      status: "form",
      mensagemErro: null,
      form: {
        senha: "",
        confirmarSenha: ""
      },
      segundosRestantes: SEGUNDOS_REDIRECIONAMENTO,
      redirectTimerId: null
    };
  },
  computed: {
    i18n() {
      const locale = this.$i18n && this.$i18n.locale;
      const pack =
        locale &&
        this.$i18n.messages[locale] &&
        this.$i18n.messages[locale].interface;
      return (pack && pack.conta && pack.conta.redefinirSenha) || {};
    },
    validationMessages() {
      return this.$route.query.lang === "en" ? EN_VALIDATION : PT_VALIDATION;
    },
    token() {
      const raw = this.$route.query.token;
      return raw ? String(raw).trim() : "";
    },
    rules() {
      const v = this.validationMessages.validation;
      return {
        senha: [
          { validator: this.validateSenha, trigger: "blur" },
          {
            required: true,
            message: v.senha.required,
            trigger: "blur"
          },
          {
            min: 6,
            message: v.senha.minLength,
            trigger: "blur"
          }
        ],
        confirmarSenha: [
          { validator: this.validateConfirmacaoSenha, trigger: "blur" },
          {
            required: true,
            message: v.confirmarSenha.required,
            trigger: "blur"
          }
        ]
      };
    },
    tituloResultado() {
      return this.status === "success"
        ? this.i18n.sucessoTitulo
        : this.i18n.erroTitulo;
    },
    descricaoResultado() {
      if (this.status === "success") {
        return this.i18n.sucessoDescricao;
      }
      return this.mensagemErro || this.i18n.erroDescricao;
    }
  },
  mounted() {
    this.aplicarLocale();
    if (!this.token) {
      this.finalizarComErro(this.i18n.tokenAusente);
    }
  },
  beforeDestroy() {
    this.pararRedirecionamento();
  },
  methods: {
    aplicarLocale() {
      applyLocaleFromQuery(this);
      if (this.$route.query.lang === "en") {
        return;
      }
      if (isBrowserLanguagePortuguese()) {
        this.$i18n.locale = "PT-BR";
      } else {
        this.$i18n.locale = "EN";
      }
    },
    formatarMensagem(chave, valor) {
      const template = this.i18n[chave];
      if (!template) {
        return "";
      }
      return String(template).replace("{0}", String(valor));
    },
    validateSenha(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.validationMessages.validation.senha.required));
      } else {
        if (this.form.confirmarSenha !== "") {
          this.$refs.form.validateField("confirmarSenha");
        }
        callback();
      }
    },
    aplicarErrosValidacaoServidor(fieldErrors) {
      if (!this.$refs.form || !fieldErrors) {
        return;
      }
      this.$nextTick(() => {
        const fields = this.$refs.form.fields || [];
        Object.keys(fieldErrors).forEach(campoApi => {
          const texto = fieldErrors[campoApi];
          if (typeof texto !== "string") {
            return;
          }
          const field = fields.find(f => f.prop === campoApi);
          if (field) {
            field.validateState = "error";
            field.validateMessage = texto;
          }
        });
      });
    },
    validateConfirmacaoSenha(rule, value, callback) {
      if (value === "") {
        callback(
          new Error(this.validationMessages.validation.confirmarSenha.required)
        );
      } else if (value !== this.form.senha) {
        callback(
          new Error(this.validationMessages.validation.confirmarSenha.match)
        );
      } else {
        callback();
      }
    },
    submitForm() {
      if (!this.$refs.form) {
        return;
      }
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        this.status = "loading";
        try {
          await LoginService.redefinirSenha({
            token: this.token,
            senha: this.form.senha
          });
          this.status = "success";
          this.$nextTick(() => this.iniciarRedirecionamento());
        } catch (err) {
          if (err && err.status === 400 && err.fieldErrors) {
            this.status = "form";
            this.aplicarErrosValidacaoServidor(err.fieldErrors);
            return;
          }
          this.finalizarComErro((err && err.message) || null);
        }
      });
    },
    finalizarComErro(mensagem) {
      this.status = "error";
      this.mensagemErro = mensagem;
      this.$nextTick(() => this.iniciarRedirecionamento());
    },
    iniciarRedirecionamento() {
      this.pararRedirecionamento();
      this.segundosRestantes = SEGUNDOS_REDIRECIONAMENTO;
      this.redirectTimerId = setInterval(() => {
        if (this.segundosRestantes <= 1) {
          this.irParaLogin();
          return;
        }
        this.segundosRestantes -= 1;
      }, 1000);
    },
    pararRedirecionamento() {
      if (this.redirectTimerId) {
        clearInterval(this.redirectTimerId);
        this.redirectTimerId = null;
      }
    },
    irParaLogin() {
      this.pararRedirecionamento();
      this.$router.push({ name: "login" });
    }
  }
};
</script>

<style scoped>
.redefinir-senha {
  min-height: 75vh;
  display: flex;
  flex-direction: column;
}

.el-main {
  display: flex;
  justify-content: center;
}

.redefinir-senha-container {
  margin-top: 50px;
  width: 100%;
  max-width: 520px;
}

.redefinir-senha-card {
  border-radius: 10px;
  background: #fafbfc;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.redefinir-senha-card-container {
  display: flex;
  justify-content: center;
}

.estado {
  text-align: center;
  padding: 8px 12px 4px;
}

.estado--form {
  text-align: left;
}

.estado--form h3 {
  text-align: center;
}

.estado h3 {
  color: #295661;
  font-family: Nunito, sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin: 12px 0;
}

.descricao {
  color: #3d4f57;
  font-size: 14px;
  line-height: 1.55;
  margin: 0 0 16px;
}

.estado--form .descricao {
  text-align: center;
}

.redefinir-senha-form.login-form {
  max-width: 400px;
  margin: 8px auto 0;
}

.redefinir-senha-form__acao {
  margin-top: 25px !important;
  margin-bottom: 0 !important;
}

.redirect-hint {
  color: #295661;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
  margin: 0 0 20px;
}

.estado-icone {
  font-size: 48px;
  color: #295661;
}

.estado-icone--sucesso {
  color: #2e7d32;
}

.estado-icone--erro {
  color: #c62828;
}
</style>

<style>
.redefinir-senha >>> .redefinir-senha-card .el-card__body {
  padding-bottom: 14px;
}

.redefinir-senha .redefinir-senha-form .el-form-item {
  margin-bottom: 18px !important;
}

.redefinir-senha
  .redefinir-senha-form
  .el-form-item.redefinir-senha-form__acao {
  margin-bottom: 0 !important;
}

.redefinir-senha .redefinir-senha-form .el-form-item__error {
  position: static;
  padding-top: 4px;
  line-height: 1.35;
}

.redefinir-senha .redefinir-senha-form .el-form-item.is-error .el-input__inner {
  border-color: #f56c6c;
}

.redefinir-senha .redefinir-senha-form .el-form-item__label span {
  color: #9f9f9f;
}

.redefinir-senha
  .redefinir-senha-form
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before,
.redefinir-senha
  .redefinir-senha-form
  .el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before {
  content: none !important;
  margin-right: 0 !important;
}

.redefinir-senha
  .redefinir-senha-form
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:after,
.redefinir-senha
  .redefinir-senha-form
  .el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
}
</style>
